import _omit from "lodash/omit";

const FIELDS_TO_REMOVE = [
    "url",
    "created",
    "name",
    "secret_id",
    "uris",
    "booth",
    "configurations"
];

export const DeploymentCreateController = ($scope,
                                          $mdDialog,
                                          callback,
                                          userCompany,
                                          sourceDeployment) => {
    "ngInject";
    $scope.deployment = {};
    $scope.callback = callback;
    $scope.sourceDeployment = sourceDeployment;

    // clone deployment if sourceDeployment provided
    $scope.sourceDeployment && ($scope.deployment = angular.copy(_omit(sourceDeployment, FIELDS_TO_REMOVE)));
    $scope.deployment.name = $scope.sourceDeployment ? `${$scope.sourceDeployment.name} (copy)` : "";
    $scope.deployment.company = $scope.sourceDeployment ? $scope.sourceDeployment.company : userCompany.url;
    $scope.selectedCompany = userCompany ? [userCompany] : [];
    $scope.deployment.configurations = [];

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.create = () => {
        callback($scope.deployment);
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            if ($scope.deployment.company && $scope.deployment.name && $scope.deployment.name.length >= 7) {
                $scope.create();
            }
        }
    };
};


// WEBPACK FOOTER //
// ./sources/components/deployments/deployment-create/deployment-create.js